import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ProductsPage = () => {
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    productName: '',
    indiaPostRate: '',
    otherPostRate: '',
    quantity: '',
    totalQuantity: '',
    weight: '',
    length: '',
    breadth: '',
    height: '',
    hsnNo: '',
    price:'',
    active: false,
    id: null,
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await axios.get('https://astrovidhya.in/api/products');
      setProductList(response.data);
    } catch (error) {
      console.error('Error fetching product list:', error);
      setError('Failed to fetch product list. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.productName || !formData.indiaPostRate || !formData.otherPostRate || !formData.quantity || !formData.totalQuantity || !formData.hsnNo) {
      setFormError('All fields are required.');
      return;
    }

    const method = formData.id ? 'PUT' : 'POST';
    const url = formData.id
      ? `https://astrovidhya.in/api/products/${formData.id}`
      : 'https://astrovidhya.in/api/products';

    try {
      const response = await axios({
        method,
        url,
        data: formData,
      });

      if (method === 'POST') {
        setProductList([...productList, response.data]);
      } else {
        setProductList(productList.map((product) =>
          product._id === response.data._id ? response.data : product
        ));
      }

      setSuccessMessage('Product added/updated successfully!');
      resetForm();
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormError('Failed to submit data. Please try again.');
    }
  };

  const handleRowClick = (product) => {
    setFormData({
      ...product,
      id: product._id,
    });
  };

  const resetForm = () => {
    setFormData({
      productName: '',
      indiaPostRate: '',
      otherPostRate: '',
      quantity: '',
      totalQuantity: '',
      weight: '',
      length: '',
      breadth: '',
      height: '',
      hsnNo: '',
      price:'',
      active: false,
      id: null,
    });
    setFormError('');
    setSuccessMessage('');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        await axios.delete(`https://astrovidhya.in/api/products/${id}`);
        setProductList(productList.filter((product) => product._id !== id));
        setSuccessMessage('Product deleted successfully!');
      } catch (error) {
        console.error('Error deleting product:', error);
        setError('Failed to delete product. Please try again.');
      }
    }
  };

  return (
    <div className="flex flex-row gap-6 p-6">
      {/* Form Panel */}
<div className="w-1/4 bg-white rounded-lg shadow-md p-6">
  <h3 className="text-lg font-bold mb-4">Product Management</h3>
  <form onSubmit={handleSubmit} className="space-y-4">
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Product Name</label>
      <input
        type="text"
        name="productName"
        value={formData.productName}
        onChange={handleChange}
        
        className="w-2/3 px-3 py-2 border rounded-md"
        maxLength={40} // Maximum of 40 characters allowed
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">India Post Rate</label>
      <input
        type="number"
        name="indiaPostRate"
        value={formData.indiaPostRate}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Other Post Rate</label>
      <input
        type="number"
        name="otherPostRate"
        value={formData.otherPostRate}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Quantity</label>
      <input
        type="number"
        name="quantity"
        value={formData.quantity}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Total Quantity</label>
      <input
        type="number"
        name="totalQuantity"
        value={formData.totalQuantity}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Weight</label>
      <input
        type="number"
        name="weight"
        value={formData.weight}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Length</label>
      <input
        type="number"
        name="length"
        value={formData.length}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Breadth</label>
      <input
        type="number"
        name="breadth"
        value={formData.breadth}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>
    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">Height</label>
      <input
        type="number"
        name="height"
        value={formData.height}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>

    <div className="flex items-center gap-4">
    <label className="text-gray-700 font-medium w-1/4">Price (₹)</label>
    <input
        type="number"
        name="price"
        value={formData.price}
        onChange={handleChange}
        placeholder="Enter price per unit"
        className="flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
        required
    />
</div>

    <div className="flex items-center gap-4">
      <label className="w-1/3 text-gray-700 font-medium pb-5">HSN No.</label>
      <input
        type="text"
        name="hsnNo"
        value={formData.hsnNo}
        onChange={handleChange}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
    </div>


         

          <div className="flex items-center space-x-2">
  <input
    id="active"
    type="checkbox"
    name="active"
    checked={formData.active}
    onChange={handleChange}
    className="h-5 w-5 text-[#03C9D7] focus:ring-[#03C9D7] border-gray-300 rounded"
  />
  <label htmlFor="active" className="text-gray-700 font-bold pb-5 pl-2">
    Active
  </label>
</div>

          <div className="flex gap-4">
            <button type="submit" className="bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2">
              Submit
            </button>
            <button type="button" onClick={resetForm} className="bg-gray-500 hover:bg-gray-700 text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2">
              Reset
            </button>
          </div>
        </form>
      </div>

      {/* List Panel */}
      <div className="w-3/4 bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-bold mb-4">Product List</h3>
        <table className="table-auto w-full text-left">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2">Product Name</th>
              <th className="px-4 py-2">India Post Rate</th>
              <th className="px-4 py-2">Other Post Rate</th>
              <th className="px-4 py-2">Quantity</th>
              
              <th className="px-4 py-2">Total Quantity</th>
              <th className="px-4 py-2">Weight</th>
              <th className="px-4 py-2">Length</th>
              <th className="px-4 py-2">Breadth</th>
              <th className="px-4 py-2">Height</th>
              <th className="px-4 py-2">HSN No.</th>
              <th className="px-4 py-2">Price</th>
              <th className="px-4 py-2">Active</th>
              <th className="px-4 py-2">Actions</th>
            
            </tr>
          </thead>
          <tbody>
            {productList.map((product) => (
              <tr key={product._id} className="hover:bg-gray-50">
                <td className="px-4 py-2">{product.productName}</td>
                <td className="px-4 py-2">{product.indiaPostRate}</td>
                <td className="px-4 py-2">{product.otherPostRate}</td>
                <td className="px-4 py-2">{product.quantity}</td>
                <td className="px-4 py-2">{product.totalQuantity}</td>
                <td className="px-4 py-2">{product.weight}</td>
                <td className="px-4 py-2">{product.length}</td>
                <td className="px-4 py-2">{product.breadth}</td>
                <td className="px-4 py-2">{product.height}</td>
                <td className="px-4 py-2">{product.hsnNo}</td>
                <td className="px-4 py-2">{product.price}</td>
                <td><input type="checkbox" checked={product.active} readOnly /></td>
                

                <td className="px-4 py-2">
                  <button
                    onClick={() => handleRowClick(product)}
                    className="bg-yellow-500 text-white px-2 py-1 rounded mr-2 w-1/3"
                  >
                    Edit
                  </button>
              
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(product._id);
                    }}
                    className="bg-red-500 text-white px-2 py-1 rounded w-1/2"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductsPage;
